import Title from '@/components/InspectionReport/Items/Questions/Title';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, {
        props, data, parent, _v,
    }) {
        return h(
            'div',
            data,
            [
                h(Title, {}, props.item.title),
                _v(parent.$du(props.resource.conducted_at, 'shortDateTime')),
            ],
        );
    },
};
